<template>
  <section >
    <el-row>
      <el-col :span="20">
        <el-form :inline="true" :model="filterForm" class="demo-form-inline">
          <el-form-item label="客户名称：">
            <el-input v-model="filterForm.cust_name" size="small" placeholder="请输入客户名称"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getCustomerList">筛选</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <el-col :span="4">
        <el-button type="primary" size="small" @click="customerDialogVisible = true">新增</el-button>
      </el-col>
    </el-row>

    <el-table :data="tableData" stripe border style="width: 100%" v-loading="loading">
      <el-table-column type="index" label="序号" width="50" align="center">
      </el-table-column>
      <el-table-column prop="cust_name" label="客户名称" align="center" min-width="100">
      </el-table-column>
      <el-table-column prop="create_time" label="创建时间" width="160" align="center">
      </el-table-column>
      <el-table-column prop="cust_contact" label="联系人" align="center" width="100">
      </el-table-column>
      <el-table-column prop="cust_telenum" label="联系电话" align="center" width="120">
      </el-table-column>
      <el-table-column prop="cust_code" label="注册码数量" align="center" width="100">
      </el-table-column>
      <el-table-column prop="cust_comment" label="备注" align="center" min-width="100">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="handleSubUser(scope.row)">子用户管理</el-button>
          <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button @click="handleDelete(scope.row.cust_id)" type="text" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background layout="prev, pager, next" :total="total" @current-change="changePage" style="text-align:right;margin-top:10px;">
    </el-pagination>

    <el-dialog title="编辑客户" :visible.sync="customerDialogVisible" width="30%" :close-on-click-modal="false" :show-close="false" :close-on-press-escape="false">
      <el-form label-width="80px" :model="customerForm" ref="customerForm" :rules="customerFormRules">
        <el-form-item label="名称" prop="cust_name">
          <el-input v-model="customerForm.cust_name"></el-input>
        </el-form-item>
        <el-form-item label="联系人" prop="cust_contact">
          <el-input v-model="customerForm.cust_contact"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="cust_telenum">
          <el-input v-model="customerForm.cust_telenum"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="customerForm.cust_comment"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="resetCustomer" v-loading="handleLoading">取 消</el-button>
        <el-button type="primary" @click="handleSubmit" v-loading="handleLoading">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 子用户 -->
    <el-dialog :title="'正在编辑客户 ' + currentUser.cust_name + ' 的子用户'" :visible.sync="subUserDialogVisible" :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="subuser-box">
        <el-form ref="subuserform" label-width="80px" :model="subUserForm" :rules="customerFormRules" size="mini">
          <el-form-item label="名称" prop="cust_name">
            <el-input v-model="subUserForm.cust_name"></el-input>
          </el-form-item>
          <el-form-item label="联系人" prop="cust_contact">
            <el-input v-model="subUserForm.cust_contact"></el-input>
          </el-form-item>
          <el-form-item label="电话" prop="cust_telenum">
            <el-input v-model="subUserForm.cust_telenum"></el-input>
          </el-form-item>
          <el-form-item label="备注">
            <el-input v-model="subUserForm.cust_comment"></el-input>
          </el-form-item>
          <el-form-item style="text-align: right;margin-bottom: 0;">
            <el-button type="success" circle v-loading="handleLoading" @click="addSubUser">确认添加</el-button>
          </el-form-item>
        </el-form>
        <el-card class="box-card">
          <div slot="header" class="clearfix">
            <span>当前已存在子客户</span>
          </div>
          <el-tag
            v-for="(item, idx) in subUserList"
            :key="item.cust_id"
            closable
            type="info"
            @close="handleDelete(item.cust_id, 'sub#' + idx)">
            {{ item.cust_name }}
          </el-tag>
        </el-card>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getCustomerList();subUserDialogVisible = false;">完成编辑</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import {
  getCustomerList,
  addCustomer,
  updateCustomer,
  deleteCustomer,
  getSubUserList,
  getCustomListByName
} from "../../api";
export default {
  data() {
    var checkTel = (rule, value, callback) => {
      if (value != "" && !/^1\d{10}$/.test(value)) {
        callback(new Error("请输入正确的电话号码"));
      }
      callback();
    };
    return {
      filterForm:{
        cust_name:''
      },
      customerDialogVisible: false,
      customerForm: {
        cust_name: "",
        cust_contact: "",
        cust_telenum: "",
        cust_comment: ""
      },
      customerFormRules: {
        cust_name: [{ required: true, message: "请输入客户名称", trigger: "blur" }],
        // cust_contact: [{ required: true, message: "请输入联系人", trigger: "blur" }],
        cust_telenum: [
          // { required: true, message: "请输入联系电话号码", trigger: "blur" },
          // { min: 11, max: 11, message: "电话号码长度为11位数字", trigger: "blur" },
          { validator: checkTel, trigger: "blur" }
        ]
      },
      loading: false,
      handleLoading: false,
      tableData: [],
      total: 0,
      pagesize:10,
      page: 1,
      //
      currentUser: {},
      subUserDialogVisible: false,
      subUserList: [],
      subUserForm: {
        p_id: "",
        cust_name: "",
        cust_contact: "",
        cust_telenum: "",
        cust_comment: ""
      }
    };
  },
  methods: {
    handleDelete(id, t = "cus") {
      this.$confirm("此操作将删除该客户, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let s = t.split("#");
          deleteCustomer(id)
            .then(res => {
              if (res.code) {
                this.$message({
                  type: "success",
                  message: res.message
                });
                if (s[0] === "sub") {
                  this.getSubUserList();
                } else {
                  this.getCustomerList();
                }
              }
            })
            .catch(err => {
              this.$message({
                type: "error",
                message: err.message  || "服务器问题，请联系系统管理员！"
              });
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    handleEdit(item) {
      this.customerDialogVisible = true;
      this.customerForm = {
        cust_name: item.cust_name,
        cust_contact: item.cust_contact,
        cust_telenum: item.cust_telenum,
        cust_comment: item.cust_comment,
        cust_id: item.cust_id
      };
    },
    changePage(page) {
      this.page = page;
      this.getCustomerList();
    },
    resetCustomer() {
      this.$refs["customerForm"].resetFields();
      this.customerForm = {
        cust_name: "",
        cust_contact: "",
        cust_telenum: "",
        cust_comment: "",
        cust_id: ""
      };
      this.customerDialogVisible = false;
    },
    handleSubmit() {
      this.$refs["customerForm"].validate(valid => {
        if (valid) {
          this.handleLoading = true;
          if (this.customerForm.cust_id) {
            updateCustomer(this.customerForm).then(res => {
              if (res.code == 201) {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.resetCustomer();
                this.getCustomerList();
              } else {
                this.$message.error(res.message);
              }
              this.handleLoading = false;
            });
          } else {
            addCustomer(this.customerForm).then(res => {
              if (res.code == 201) {
                this.$message({
                  message: res.message,
                  type: "success"
                });
                this.resetCustomer();
                this.getCustomerList();
              } else {
                this.$message.error(res.message);
              }
              this.handleLoading = false;
            });
          }
        } else {
          this.$message({
            message: "存在必填项校验未通过或者必填项未填",
            type: "warning"
          });
        }
      });
    },
    getCustomerList() {
      this.loading = true;
      let para = {
        page: this.page,
        pagesize:this.pagesize,
        keyword:this.filterForm.cust_name
      };
      getCustomerList(para).then(res => {
      // getCustomListByName(para).then(res => {
        this.loading = false;
        if (res.code == 200) {
          this.tableData = res.data;
          this.total = res.total;
        } else {
          this.$message({
            message: res.message,
            type: "warning"
          });
        }
      }).catch(res=>{
        this.loading = false;
        this.$message({
          message: "服务器错误，请联系系统管理员！",
          type: "error"
        });
      });
    },
    ///
    getSubUserList(cust_id) {
      cust_id = cust_id || this.currentUser.cust_id;
      return new Promise((resolve, reject) => {
        getSubUserList({ cust_id }).then(res => {
          this.currentUser = res.data;
          this.subUserList = (res.data && res.data.subcusts) || [];
          resolve(res);
        }).catch(err => {
          this.subUserList = [];
          reject(err);
        });
      });
    },
    handleSubUser(userdata) {
      this.subUserForm = {
        p_id: "",
        cust_name: "",
        cust_contact: "",
        cust_telenum: "",
        cust_comment: ""
      };
      this.currentUser = userdata;
      this.subUserList = [];
      this.getSubUserList(userdata.cust_id).then(() => {
        this.subUserDialogVisible = true;
      }).catch(err => {
        this.$message({
            type: "error",
            message: err.message || err.msg || "获取失败"
          });
      });
    },
    addSubUser() {
      this.subUserForm.p_id = this.currentUser.cust_id;
      this.$refs.subuserform.validate(valid => {
        if (valid) {
          this.handleLoading = true;
          addCustomer(this.subUserForm).then(res => {
            if (res.code == 201) {
              this.$message({
                message: res.message,
                type: "success"
              });
              this.getSubUserList(this.currentUser.cust_id);
              //
              this.subUserForm = {
                p_id: "",
                cust_name: "",
                cust_contact: "",
                cust_telenum: "",
                cust_comment: ""
              };
              this.$refs.subuserform.resetFields();
            } else {
              this.$message.error(res.message);
            }
            this.handleLoading = false;
          }).catch(() => {
            this.handleLoading = false;
          });
        }
      });
    }
  },
  mounted() {
    this.getCustomerList();
  }
};
</script>
<style lang="less" scoped>
.subuser-box {
  display: flex;
  flex-direction: row;

  .el-form {
    flex: 1;
    padding-right: 20px;
  }
  .el-card {
    flex: 1;

    /deep/ .el-card__header {
      padding: 5px 10px;
    }
    /deep/ .el-card__body {
      padding: 10px;
    }
  }
  .el-tag {
    margin: 0 8px 8px 0;
  }
}
</style>




// WEBPACK FOOTER //
// src/components/customer/index.vue